import AppConfig from "src/config/AppConfig";
import Tag from "./Tag";

interface ImpactScoreValues {  
    tiny:number;
    small:number;
    medium:number;
    large:number;
    huge:number;
}

export default class Settings {
    logoUrl:string = "";
    theme:string = AppConfig.SETTINGS_THEME_NAMES.treasureHunter;
    vehicle:string = AppConfig.SETTINGS_VEHICLE_NAMES.Bus;
    stat:string = AppConfig.SETTINGS_STAT_NAMES.Health;
    maxStat:number = 100;
    minStat:number = 0;
    startingStat:number = 50;
    prefix:string = "";
    suffix:string = "";
    tags:Array<Tag> = []; 

    impactScoreValues:ImpactScoreValues = {
        tiny: 20,
        small: 50,
        medium: 100,
        large: 250,
        huge: 500,
    };

    impactStatValues:ImpactScoreValues = {
        tiny: 5,
        small: 15,
        medium: 30,
        large: 50,
        huge: 100,
    };
}



// WEBPACK FOOTER //
// ./src/objects/Settings.ts